"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Mail, MapPin, Phone } from "lucide-react";
const fallbackItems = [{
  id: "areas",
  label: "Faaliyet Alanları",
  href: "/AreasOfExpertisePage"
}, {
  id: "resume",
  label: "Özgeçmiş",
  href: "/ResumePage"
}, {
  id: "contact",
  label: "İletişim",
  href: "/ContactPage"
}];
const allowedLabels = new Set(["Faaliyet Alanları", "Özgeçmiş", "İletişim"]);
function formatMenuLabel(label: string): string {
  const normalized = (label || "").trim().toLocaleLowerCase("tr");
  if (["uzmanlık alanları", "uzmanlik alanlari", "faaliyet alanları", "faaliyet alanlari"].includes(normalized)) {
    return "Faaliyet Alanları";
  }
  if (["özgeçmiş", "ozgecmis", "resume"].includes(normalized)) {
    return "Özgeçmiş";
  }
  if (["iletişim", "iletisim", "contact"].includes(normalized)) {
    return "İletişim";
  }
  return label;
}
function FooterMenu() {
  const {
    menuItems,
    loading
  } = useMenu();
  const source = !loading && menuItems && menuItems.length > 0 ? menuItems.map(item => ({
    id: item.id,
    label: formatMenuLabel(item.label),
    href: item.href || "#"
  })) : fallbackItems;
  const seen = new Set<string>();
  const items = source.filter(item => {
    if (!allowedLabels.has(item.label) || seen.has(item.label)) {
      return false;
    }
    seen.add(item.label);
    return true;
  });
  return <ul className="space-y-3">
      {(items.length > 0 ? items : fallbackItems).map(item => <li key={item.id}>
          <Link to={item.href} className="inline-flex min-h-8 items-center font-sans text-sm text-[#f4efe5]/68 transition-colors hover:text-[#f4efe5] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#f4efe5] focus-visible:ring-offset-2 focus-visible:ring-offset-[#090909]">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <footer className="border-t border-[#f4efe5]/12 bg-[#090909] text-[#f4efe5]">
      <div className="mx-auto max-w-[1320px] px-5 py-14 sm:px-8 lg:px-10 lg:py-18">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,1.1fr)_minmax(180px,0.5fr)_minmax(260px,0.9fr)] lg:gap-16">
          <div className="min-w-0">
            <Link to="/" className="inline-flex font-serif text-[clamp(2.2rem,4vw,4.2rem)] leading-none text-[#f4efe5] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#f4efe5] focus-visible:ring-offset-2 focus-visible:ring-offset-[#090909]">
              Yüksekbaş Hukuk ve Danışmanlık
            </Link>
          </div>

          <div className="min-w-0">
            <h3 className="mb-5 font-sans text-sm text-[#f4efe5]">Sayfalar</h3>
            <MenuProvider menu_id="40">
              <FooterMenu />
            </MenuProvider>
          </div>

          <div className="min-w-0">
            <h3 className="mb-5 font-sans text-sm text-[#f4efe5]">İletişim</h3>
            <div className="space-y-5 font-sans text-sm leading-6 text-[#f4efe5]/68">
              <div className="flex gap-3">
                <MapPin className="mt-1 size-4 shrink-0 text-[#f4efe5]/45" />
                <span>Cevizli Mahallesi, Mustafa Kemal Caddesi, Onat Sokak, No:5/8, Kartal/İstanbul</span>
              </div>
              <a href="mailto:info@yuksekbas.av.tr" className="flex min-h-8 items-center gap-3 transition-colors hover:text-[#f4efe5] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#f4efe5] focus-visible:ring-offset-2 focus-visible:ring-offset-[#090909]">
                <Mail className="size-4 shrink-0 text-[#f4efe5]/45" />
                <span>info@yuksekbas.av.tr</span>
              </a>
              <a href="tel:+902167064150" className="flex min-h-8 items-center gap-3 transition-colors hover:text-[#f4efe5] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#f4efe5] focus-visible:ring-offset-2 focus-visible:ring-offset-[#090909]">
                <Phone className="size-4 shrink-0 text-[#f4efe5]/45" />
                <span>+90 (216) 706 41 50</span>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-[#f4efe5]/12 pt-6 font-sans text-xs text-[#f4efe5]/48 sm:flex-row sm:items-center sm:justify-between">
          <span>© {new Date().getFullYear()} Yüksekbaş Hukuk ve Danışmanlık</span>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <Link to="/ContactFormPrivacyNoticePage" className="transition-colors hover:text-[#f4efe5] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#f4efe5] focus-visible:ring-offset-2 focus-visible:ring-offset-[#090909]">
              İletişim Formu Aydınlatma Metni
            </Link>
            <Link to="/PersonalDataProtectionAndProcessingPolicyPage" className="transition-colors hover:text-[#f4efe5] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#f4efe5] focus-visible:ring-offset-2 focus-visible:ring-offset-[#090909]">
              KVKK ve Gizlilik Politikası
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}